import * as pmtfmt from 'shared/payments/fmt';
import { Currency } from 'server/types';

type TaxBreakdownItem = {
  amount: number;
  rate: string;
  percentage: number;
  jurisdiction: string;
};

type Props = {
  subtotal: number;
  taxAmount: number;
  total: number;
  breakdown: TaxBreakdownItem[];
  currency: Currency;
  loading?: boolean;
};

export function TaxSummary({ subtotal, taxAmount, total, breakdown, currency, loading }: Props) {
  if (loading) {
    return (
      <div class="border-t border-gray-200 pt-3 mt-3 animate-pulse">
        <div class="h-4 bg-gray-200 rounded w-32 mb-2"></div>
        <div class="h-4 bg-gray-200 rounded w-24 mb-2"></div>
        <div class="h-5 bg-gray-200 rounded w-36"></div>
      </div>
    );
  }

  if (!taxAmount) {
    return null;
  }

  return (
    <div class="border-t border-gray-200 pt-3 mt-3 text-sm">
      <div class="flex justify-between text-gray-600 mb-1">
        <span>Subtotal</span>
        <span>{pmtfmt.price({ priceInCents: subtotal, currency })}</span>
      </div>
      {breakdown.map((item) => (
        <div class="flex justify-between text-gray-600 mb-1" key={item.rate + item.jurisdiction}>
          <span>
            {item.rate}
            {item.jurisdiction ? ` (${item.jurisdiction})` : ''}
            {item.percentage ? ` ${item.percentage}%` : ''}
          </span>
          <span>{pmtfmt.price({ priceInCents: item.amount, currency })}</span>
        </div>
      ))}
      <div class="flex justify-between font-semibold text-gray-900 pt-1 border-t border-gray-100 mt-1">
        <span>Total</span>
        <span>{pmtfmt.price({ priceInCents: total, currency })}</span>
      </div>
    </div>
  );
}
